import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import ConfirmReadTextStep from './confirm-read-text-step';
import { Panel } from 'react-bootstrap';

@inject('appStore')
@observer
export default class ConfirmReadNotesStep extends Component {
    constructor() {
        super();
    }

    formatIncompleteContent() {
        const agents = appStore.tcFileStore.selectedFile.agents;

        let i = 0;
        const notesAndPrefs = _.map(agents, agent => {
            i++;
            const agentPreferences = agent.profile.preferences;
            const brokeragePreferences = agent.brokerageProfile.preferences;
            return (
                <div key={'notes-prefs-' + agent.agentId}>
                    <h3>{agent.name}</h3>
                    <h4>Agent Preferences</h4>
                    <p dangerouslySetInnerHTML={{ __html: agentPreferences }}></p>
                    <h4>Brokerage Preferences: {agent.subscriberName}</h4>
                    <p dangerouslySetInnerHTML={{ __html: brokeragePreferences }}></p>
                    {i < agents.length ? <hr /> : null}
                </div>
            );
        });
        return notesAndPrefs;
    }

    render() {
        return (
            <ConfirmReadTextStep
                {...this.props}
                confirmMessage="Preferences confirmed"
                incompleteContent={this.formatIncompleteContent()}
                actionButtonText="Confirm"
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/workflow/steps/confirm-read-notes-step.js